module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-32.0d39bf9e.svg";